import React from 'react';
import {
  TopologyApiProvider,
} from '../../admin/hermes/topology/topologyApi';
import { TopologyView } from '../../admin/hermes/topology/TopologyPage';

/**
 * Topologia da rede — visão do CLIENTE (beta).
 *
 * Mesma tela do admin, com duas diferenças que não são cosméticas:
 *
 *   1. Não há seletor de empresa. O caminho base é `/topology`, sem nenhum
 *      identificador: a API resolve a empresa pelo TOKEN. Se ela viesse daqui,
 *      um bug de estado nesta tela pediria a rede de outro provedor.
 *
 *   2. O rebuild passa pela rota com trava de 15 minutos.
 *
 * Reaproveita a view do admin em vez de copiá-la: são ~3.700 linhas de lógica de
 * visualização (layout, camadas OSI, realce de VLAN, trace de caminho). Duas
 * cópias divergiriam no primeiro ajuste, e a versão do cliente é justamente a
 * que ninguém lembraria de atualizar.
 */
export default function TopologiaCliente() {
  return (
    <TopologyApiProvider base="/topology">
      <TopologyView modo="cliente" />
    </TopologyApiProvider>
  );
}
